module.exports = __webpack_public_path__ + "img/wallet.8bf04eed.svg";